export const ShortMonth = 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec'.split(',');

export const ONE_DAY_TICKS = 1000 * 60 * 60 * 24; //milliseconds
